<template>
  <div class="videorack">
    <!-- 面包屑 -->
    <div class="Breadcrumb">
      <img
        @click="$router.replace('/Layout/Home')"
        src="~@img/icon/ui_home_page_0.png"
        alt
      />
      <a @click="$router.replace('/Layout/Home')">首页 &nbsp;/ &nbsp;</a>
      <a class="active">视频库</a>
    </div>
    <div class="main">
      <!-- 标题 -->
      <div class="learnhome_scroll">
        <div class="title_box">
          <span></span>
          <img src="@img/background/learn_text.png" alt="" />
        </div>
        <div class="main_box">
          <div class="main_r_title">视频库合集</div>
          <!-- <div class="main_r_name">学习立定跳远标准动竹与动作解析</div> -->
          <div class="category_box">
            <div class="category_list">
              <div
                class="category_list_box"
                v-for="(item, index) in list"
                :key="index"
              >
                <div class="item_title">{{ item.name }}</div>
                <div class="item_list">
                  <div
                    v-for="(item1, index) in item.videoAlls && item.videoAlls.length>5
                      ? item.videoAlls.slice(0, 5)
                      : item.videoAlls"
                    :key="index"
                    class="item_list_item"
                    @click="getDetail(item1.videoId)"
                  >
                    <div class="item_list_item_img">
                      <img :src="item1.cover" alt="" />
                    </div>
                    <div class="item_list_item_title">
                      <img src="@img/icon/ui_video.png" alt="" />{{
                        item1.name
                      }}
                    </div>
                  </div>
                  <div
                    class="more_box"
                    v-if="item.videoAlls && item.videoAlls.length >= 5"
                    @click="getMore(item)"
                  >
                    <span>更多</span>
                    <img src="@img/icon/ui_more.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.getVideo();
  },
  methods: {
    //更多
    getMore(item) {
      sessionStorage.setItem("info", JSON.stringify(item));
      this.$router.push({
        path: "learnmodel/learnmore",
        query: { titletype: 1 },
      });
    },
    // 视频详情
    getDetail(videoId) {
      this.$router.push({
        path: "videorack/videodetail",
        query: { videoId: videoId },
      });
    },
    // 接口
    getVideo() {
      this.$http.get("api/video/getAllVideoList?type=2").then((res) => {
        if (res.success) {
          this.list = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import url("~@styles/common.less");
.videorack {
  .main {
    height: calc(100vh - 200px);
    overflow: auto;
    padding: 47px 106px;
  }
  .title_box {
    display: flex;
    align-items: center;
    height: 48px;
    span {
      width: 6px;
      height: 100%;
      background: #ffa216;
      border-radius: 1px;
    }
    img {
      margin-left: 16px;
      width: 465px;
      height: 100%;
    }
  }
  .main_box {
    margin: 31px 0 0;
    padding: 18px 17px;
    background: #ffffff;
    border: 1px solid #c0c0c0;
    border-radius: 5px;
    .main_r_title {
      color: #ffa216;
      font-size: 25px;
      font-weight: bold;
      line-height: 33px;
    }
    .main_r_name {
      padding: 5px 0 0;
      color: #313131;
      font-size: 20px;
      font-weight: 400;
      line-height: 19px;
    }
    .category_box {
      .category_list {
        .category_list_box {
          border-bottom: 1px solid #7070707e;
        }
        .category_list_box:last-child {
          border: none;
        }
        .item_title {
          padding: 18px 0 0;
          font-size: 23px;
          font-weight: bold;
          line-height: 30px;
          color: #313131;
        }
        .item_list {
          padding: 16px 0;
          display: flex;
          .item_list_item {
            width: 280px;
            cursor: pointer;
            margin-right: 36px;
            .item_list_item_img {
              width: 100%;
              width: 280px;
              height: 157px;
              border: 1px solid #707070;
              border-radius: 5px;
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                vertical-align: top;
              }
            }
            .item_list_item_title {
              padding: 12px 0 0;
              display: flex;
              color: #313131;
              font-size: 20px;
              line-height: 26px;
              font-weight: 400;
              img {
                margin-top: 1px;
                margin-right: 3px;
                width: 24px;
                height: 24px;
              }
            }
          }
          .more_box {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 91px;
            height: 157px;
            color: #ffa216;
            font-size: 20px;
            font-weight: bold;
            background: #fff1d1;
            border-radius: 5px;
            cursor: pointer;
            span {
              height: 26px;
              margin-right: 2px;
            }
            img {
              width: 19px;
              height: 26px;
            }
          }
        }
      }
    }
  }
}
</style>